import { render, staticRenderFns } from "./LayoutAside.vue?vue&type=template&id=654c0af0"
import script from "./LayoutAside.vue?vue&type=script&lang=js"
export * from "./LayoutAside.vue?vue&type=script&lang=js"
import style0 from "./LayoutAside.vue?vue&type=style&index=0&id=654c0af0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports